import React, { useEffect } from "react";
import { useState } from "react";
import Api from "../../Api";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

const Admin = () => {


  const [data, setData] = useState([]);
  const [campos, setCampos] = useState([]);

  useEffect(() => {
    const user = prompt("Digite o usuário");
    const password = prompt("Digite a senha");
    if ( user === "bupin@ansuz" && password === "bupin@ansuz") {
      Api.get("listar").then((res) => {
        //format date
        res.data.map((obj) => {
          obj.data_cadastro = new Date(obj.data_cadastro).toLocaleDateString(
            "pt-BR"
          );
        });
        setData(res.data.map((obj) => Object.values(obj)));
        setCampos(Object.keys(res.data[0]));
      });
    } else {
      alert("Usuário ou senha incorretos");
    }
  }, []);

  return (
    <>
      <div style={{ marginTop: 50 }}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                {campos.map((campo) => (
                  <TableCell>{campo}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row) => (
                <TableRow
                  key={row.id}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  {row.map((item) => (
                    <TableCell component="th" scope="row">
                      {item}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
};

export default Admin;
